import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  rules: [],
  alerts: [],
  currentRule: null,
  currentAlert: null,
  stats: {
    total: 0,
    firing: 0,
    resolved: 0,
    acknowledged: 0,
  },
  loading: false,
  error: null,
}

const alertSlice = createSlice({
  name: 'alert',
  initialState,
  reducers: {
    // Alert rules
    setRules: (state, action) => {
      state.rules = action.payload
      state.loading = false
      state.error = null
    },
    setCurrentRule: (state, action) => {
      state.currentRule = action.payload
    },
    addRule: (state, action) => {
      state.rules.unshift(action.payload)
    },
    updateRule: (state, action) => {
      const index = state.rules.findIndex(r => r.id === action.payload.id)
      if (index !== -1) {
        state.rules[index] = action.payload
      }
    },
    removeRule: (state, action) => {
      state.rules = state.rules.filter(r => r.id !== action.payload)
    },

    // Alerts
    setAlerts: (state, action) => {
      state.alerts = action.payload
      state.loading = false
      state.error = null
    },
    setCurrentAlert: (state, action) => {
      state.currentAlert = action.payload
    },
    updateAlert: (state, action) => {
      const index = state.alerts.findIndex(a => a.id === action.payload.id)
      if (index !== -1) {
        state.alerts[index] = action.payload
      }
    },

    // Stats
    setStats: (state, action) => {
      state.stats = action.payload
    },

    // Loading and error
    setLoading: (state, action) => {
      state.loading = action.payload
    },
    setError: (state, action) => {
      state.error = action.payload
      state.loading = false
    },
    clearError: (state) => {
      state.error = null
    },
  },
})

export const {
  setRules,
  setCurrentRule,
  addRule,
  updateRule,
  removeRule,
  setAlerts,
  setCurrentAlert,
  updateAlert,
  setStats,
  setLoading,
  setError,
  clearError,
} = alertSlice.actions

export default alertSlice.reducer

// Selectors
export const selectAlertRules = (state) => state.alert.rules
export const selectAlerts = (state) => state.alert.alerts
export const selectCurrentRule = (state) => state.alert.currentRule
export const selectCurrentAlert = (state) => state.alert.currentAlert
export const selectAlertStats = (state) => state.alert.stats
export const selectAlertLoading = (state) => state.alert.loading
export const selectAlertError = (state) => state.alert.error

